import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import VueScrollTo from 'vue-scrollto'
import machineEverFilm from "../component/pages/machineIntroduction/MachineEverFilm.vue";

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')
const isSearchableStr = document.getElementById('isSearchable').textContent
const isSearchable = isSearchableStr.toLowerCase() === "true"

const vue = createApp(
    machineEverFilm,
    {
        unsavedPuriCount: unsavedPuriCount,
        latestImageId: latestImageId,
        isSearchable: isSearchable,
    }
)
    .use(Store)
    .use(VueScrollTo)
    .mount('#everfilm')

export default vue
